<app-employee-attendance-stats *ngIf="loggedEmployeeID" [employeeID]="loggedEmployeeID" [placement]="'ATTENDANCE'"></app-employee-attendance-stats>
<div class="row">
  <div class="col-12 position-static">
    <router-outlet></router-outlet>
  </div>
</div>
